import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

const PageRoot = lazy(() => import('@app/components/PageRoot'))
const OrdersEmptyPage = lazy(() => import('.'))

class OrdersEmptyPageWebComponent extends ReactWebComponent {
	override render() {
		return (
			<PageRoot>
				<OrdersEmptyPage />
			</PageRoot>
		)
	}
}

customElements.define('orders-empty-page', OrdersEmptyPageWebComponent)
